import * as Yup from "yup";

export const triggerImportSchema = Yup.object().shape({
  rlFile: Yup.mixed().required("RouteLine File is required").nullable(),
});